import { useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Products from './components/Products';
import ProductDetails from './components/ProductDetails';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const handleProductSelect = (product: any) => {
    setSelectedProduct(product);
    const detailsSection = document.getElementById('detalles-producto');
    if (detailsSection) {
      detailsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 relative">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-2 h-2 bg-cyan-400 rounded-full animate-pulse opacity-60"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-blue-400 rounded-full animate-pulse delay-1000 opacity-40"></div>
        <div className="absolute bottom-32 left-20 w-2 h-2 bg-teal-400 rounded-full animate-pulse delay-2000 opacity-50"></div>
        <div className="absolute top-60 left-1/4 w-1 h-1 bg-emerald-400 rounded-full animate-pulse delay-3000 opacity-70"></div>
        <div className="absolute bottom-40 right-1/3 w-2 h-2 bg-orange-400 rounded-full animate-pulse delay-4000 opacity-30"></div>
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-cyan-500/5 to-blue-500/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-teal-500/5 to-emerald-500/5 rounded-full blur-3xl animate-pulse delay-2000"></div>
      </div>

      <Navigation />
      
      <main>
        <section id="inicio">
          <Hero />
        </section>
        
        <section id="productos">
          <Products onProductSelect={handleProductSelect} />
        </section>
        
        <section id="detalles-producto">
          <ProductDetails selectedProduct={selectedProduct} />
        </section>
        
        <section id="sobre-nosotros">
          <About />
        </section>
        
        <section id="contacto">
          <Contact />
        </section>
      </main>

      <Footer />
    </div>
  );
}